import { render, staticRenderFns } from "./index.vue?vue&type=template&id=163e161b&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"
import style0 from "./index.vue?vue&type=style&index=0&id=163e161b&prod&lang=less"
import style1 from "./index.vue?vue&type=style&index=1&id=163e161b&prod&lang=less&scoped=true"
import style2 from "./index.vue?vue&type=style&index=2&id=163e161b&prod&lang=less&scoped=true"
import style3 from "./index.vue?vue&type=style&index=3&id=163e161b&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "163e161b",
  null
  
)

export default component.exports